export enum MeetingStatus {
  "Geplant" = "Geplant",
  "Live" = "Live",
  "Beendet" = "Beendet",
}
